import React, { useEffect, useRef, useState } from "react";
import VideoCallOutlinedIcon from "@material-ui/icons/VideoCallOutlined";
import KeyboardRoundedIcon from "@material-ui/icons/KeyboardRounded";
import Navbar from "../../components/navbar/Navbar";
import meetingImg from "../../assets/meeting.svg";
import "./style.scss";
import { v4 as uuid } from "uuid";
import { useHistory } from "react-router-dom";

const CreateClass = () => {
  const [meetingCode, setMeetingCode] = useState("");
  const [maintenanceOpen, setMaintenanceOpen] = useState(false);
  const joinWithCode = useRef(null);
  const joinBtn = useRef(null);
  const history = useHistory();

  const MAINTENANCE_MSG = "Live class is temporarily under maintenance. This feature will be back soon.";

  const showHideJoinBtn = () => {
    if (!meetingCode) {
      joinWithCode.current?.classList?.toggle("show-joinBtn");
    }
  };

  useEffect(() => {
    if (meetingCode) {
      joinBtn.current?.classList?.remove("disabled");
    }

    if (!meetingCode) {
      joinBtn.current?.classList?.add("disabled");
    }
  }, [meetingCode]);

  const handleJoinWithCode = () => {
    // Maintenance mode: block action and show popup
    setMaintenanceOpen(true);

    // Keep original navigation logic for future use (do not remove code)
    // const extractCode = (input) => {
    //   if (!input) return "";
    //   const trimmed = String(input).trim();
    //   try {
    //     const url = new URL(trimmed);
    //     const parts = url.pathname.split("/").filter(Boolean);
    //     if (parts[0] === "class" && parts[1]) return parts[1];
    //     return trimmed;
    //   } catch (e) {
    //     return trimmed;
    //   }
    // };
    // const code = extractCode(meetingCode);
    // if (code) history.push(`/class/${code}`);
  };

  const handleCreateMeeting = (e) => {
    // Maintenance mode: block action and show popup
    setMaintenanceOpen(true);

    // Keep original creation logic for future use (do not remove code)
    // const newClassId = uuid();
    // console.log(newClassId);
    // history.push(`/class/${newClassId}`)
  }

  return (
    <>
      <Navbar />
      <div className="createClass">
        <div className="left">
          <div className="textContent">
            <h1>Create free live classes</h1>
            <h1>or group discussions.</h1>
            <p>Click New meeting to start new meeting,</p>
            <p>or enter meeting code or link to Join.</p>
          </div>

          <div className="btn-container">
            <button className="createBtn" onClick={handleCreateMeeting}>
              <VideoCallOutlinedIcon className="icon" /> New meeting
            </button>

            <div className="joinWithCode" id="joinWithCode" ref={joinWithCode}>
              <div className="code-input">
                <KeyboardRoundedIcon className="icon" />
                <input
                  type="text"
                  placeholder="Enter a code or link"
                  onChange={(e) => setMeetingCode(e.target.value)}
                  onFocus={showHideJoinBtn}
                  onBlur={showHideJoinBtn}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleJoinWithCode(); } }}
                />
              </div>

              <button
                className="joinBtn disabled"
                ref={joinBtn}
                onClick={handleJoinWithCode}
              >
                Join
              </button>
            </div>
          </div>
        </div>

        <div className="right">
          <img src={meetingImg} alt="profileimg" />
        </div>
      </div>
      {maintenanceOpen && (
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}}>
        <div style={{background:"#fff",borderRadius:12,padding:"20px 24px",maxWidth:420,width:"90%",boxShadow:"0 10px 30px rgba(0,0,0,0.2)"}}>
          <h3 style={{margin:"0 0 8px",color:"#111"}}>Feature under maintenance</h3>
          <p style={{margin:"0 0 16px",color:"#444",lineHeight:1.5}}>{MAINTENANCE_MSG}</p>
          <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
            <button onClick={()=>setMaintenanceOpen(false)} style={{padding:"8px 14px",borderRadius:8,border:"1px solid #ddd",background:"#fff",cursor:"pointer"}}>Close</button>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default CreateClass;
